import type { ActionTree, Module, MutationTree } from 'vuex'
import { IMessage } from '@/types'
import type { IState } from '@/store'

export interface IMessagesState {
  all: IMessage[]
}

const state = (): IMessagesState => ({
  all: [],
})

const mutations: MutationTree<IMessagesState> = {
  push(state, message: IMessage) {
    state.all.push(message)
  },
  removeByIndex(state, index: number) {
    if (index < 0 || index >= state.all.length) {
      return
    }

    state.all.splice(index, 1)
  },
}

const actions: ActionTree<IMessagesState, IState> = {
  add({ commit }, message: IMessage) {
    commit('push', message)
  },
}

export const Messages: Module<IMessagesState, IState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}
